// Welcome.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import AboutUs from './AboutUs';
import NewsPromotions from './NewsPromotions';
import './about.css';

function Welcome() {
  return (
    <div>
      <section className="about-page">
        <Container className="about-wrap">
          <div className="about-hero">
            <div className="about-hero-left">
              <div className="about-pill">WELCOME TO DTE</div>
              <h1 className="about-title">Engineering Solutions That Flow</h1>
              <p className="about-subtitle">
                We provide practical, field-oriented solutions in water systems installation, mechanical works, fabrication, and maintenance services — improving water access and infrastructure reliability across Malawi.
              </p>

              <div className="about-cta-row">
                <Link className="about-cta" to="/contact">
                  Get Started
                </Link>
                <Link className="about-cta about-cta-secondary" to="/projects">
                  Our Work
                </Link>
                <Link className="about-cta about-cta-secondary" to="/quote">
                  Get a Quote
                </Link>
              </div>
            </div>

            <div className="about-hero-right">
              <img
                className="about-hero-image"
                src="/images/20.jpg"
                alt="Divine-Tech Engineering"
              />
            </div>
          </div>

          <Row className="about-grid">
            <Col md={4} className="about-col">
              <div className="about-card">
                <div className="about-card-title">Projects Completed</div>
                <div className="about-copy">
                  <p>
                    <span className="about-strong">150+</span> successful installations, repairs, and fabrication projects.
                  </p>
                </div>
              </div>
            </Col>

            <Col md={4} className="about-col">
              <div className="about-card">
                <div className="about-card-title">Client Satisfaction</div>
                <div className="about-copy">
                  <p>
                    <span className="about-strong">95%</span> satisfaction based on delivery, quality, and reliability.
                  </p>
                </div>
              </div>
            </Col>

            <Col md={4} className="about-col">
              <div className="about-card">
                <div className="about-card-title">Services Offered</div>
                <div className="about-copy">
                  <p>
                    <span className="about-strong">20+</span> services across water systems and mechanical works.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <NewsPromotions />
      <AboutUs />
    </div>
  );
}

export default Welcome;
